import { Container, Typography, Box, Card, CardContent, Grid } from '@mui/material';

function Courses() {
  const courses = [
    {
      title: "Bhagavad Gita",
      description: "Comprehensive study of the timeless dialogue between Lord Krishna and Arjuna."
    },
    {
      title: "Srimad Bhagavatam",
      description: "In-depth exploration of the supreme Vedic scripture describing Krishna's pastimes."
    },
    {
      title: "Chaitanya Charitamrita",
      description: "Study of Lord Chaitanya's teachings and the philosophy of divine love."
    },
    {
      title: "Vedic Philosophy",
      description: "Introduction to fundamental concepts of Vedic wisdom and spiritual practice."
    }
  ];

  return (
    <Box sx={{ py: 8 }}>
      <Container>
        <Typography variant="h3" component="h2" gutterBottom textAlign="center">
          Our Courses
        </Typography>
        <Grid container spacing={4}>
          {courses.map((course, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Typography variant="h5" component="h3" gutterBottom>
                    {course.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {course.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Courses; 